import Vue from 'vue';
import Vuex from 'vuex';
import OfferModule from './modules/OfferModule.js';
// import OfferModule from '@/store/modules/OfferModule.js';

Vue.use(Vuex);

const _localStorage = window.localStorage || {
  setItem: () => true,
  getItem: () => null,
};

// let mockSchedule = {
//   startTime: '2019-01-21T03:30:00Z',
//   endTime: '2019-01-21T07:00:00Z',
//   locationName: 'Loco, El Burrito, Surry Hills',
//   _metadata: {
//     offer: {
//       acceptedApplicant: {},
//       state: 'UNKNOWNS_STATE',
//       creator: {
//         firstName: 'Arnold',
//         lastName: 'Strange',
//       },
//     },
//   },
// };

// if (process.env.MOCK) {
//   mock = require('@/mock.yaml');
// }

const store = new Vuex.Store({
  plugins: [],
  modules: {
    Offer: OfferModule,
  },
  strict: process.env.NODE_ENV !== 'production',
  state: {
    // ids required for jwt
    userId: null,
    scheduleId: null,
    offerId: null,
    session: null,
  },

  getters: {
    session: state => !!state.session,
  },
  mutations: {
    setSession(state, { userId, scheduleId, offerId, jwt }) {
      state.session = userId + scheduleId + offerId;
      state.userId = userId;
      state.scheduleId = scheduleId;
      state.offerId = offerId;
      _localStorage.setItem('DEPUTY_SO:userId', userId);
      _localStorage.setItem('DEPUTY_SO:scheduleId', scheduleId);
      _localStorage.setItem('DEPUTY_SO:offerId', offerId);
      _localStorage.setItem('DEPUTY_SO:jwt', jwt);
    },
  },

  actions: {
    setSession({ commit }, payload) {
      commit('setSession', payload);
    },
  },
});

export default store;
